import IpsInput from './IpsInput.vue';
import '../../../styles/custom.scss';

export default IpsInput;
